import React, { createRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BsCart4, BsFileText } from "react-icons/bs";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { IoCartOutline } from "react-icons/io5";
import { useMeData } from "../../hooks/serviceMe";
import { useAuth } from "../../context/AuthContext";
import { useServiceUser } from "../../hooks/serviceUser";
import { toast } from "react-toastify";
import getNotifications from "../../hooks/serviceNotifications";
import ic_logo from "../../assets/images/new-logo-colorida.png";

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const type = localStorage.getItem("userType");
  const token = localStorage.getItem("token");
  const { data, isLoading } = useMeData();
  const [isOpen, setIsOpen] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const { logout } = useAuth();
  const { user, me } = useAuth();
  const [isOpenTermsOfUse, setIsOpenTermsOfUse] = useState(false);
  const { acceptTermsOfUse } = useServiceUser();
  const [contentTerms, setContentTerms] = useState("");
  const navRef = createRef<HTMLDivElement>();
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const changeLanguage = (lng: string) => {
    localStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const onCloseTermsOfUse = () => {
    logout();
  };

  const handleLogout = () => {
    logout();
  };

  const acceptTermsOfUseClick = () => {
    acceptTermsOfUse()
      .then(() => {
        setIsOpenTermsOfUse(false);
        toast.success(t("terms-accepted-successfully!"), {
          position: toast.POSITION.TOP_CENTER,
        });
        me();
      })
      .catch(() => {
        toast.error(t("error-accepting-terms-of-use"), {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  useEffect(() => {
    const fetchLanguage = async () => {
      const storedLanguage = await localStorage.getItem("language");
      if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
      }
    };

    if (user?.terms_of_use) {
      if (localStorage.getItem("language") === "en") {
        setContentTerms(user.terms_of_use_en);
      } else {
        setContentTerms(user.terms_of_use);
      }
    }

    if (
      token &&
      type !== "satelite" &&
      (user?.is_accept_terms_of_use === false ||
        user?.is_accept_terms_of_use === null)
    ) {
      setIsOpenTermsOfUse(true);
    }

    fetchLanguage();
  }, [i18n, user]);

  useEffect(() => {
    if (!navRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      setNavHeight(navRef.current?.getBoundingClientRect().height || navHeight);
    });
    resizeObserver.observe(navRef.current);
    return () => resizeObserver.disconnect();
  }, [navRef, navHeight]);

  useEffect(() => {
    const fetchNotificationsCount = async () => {
      try {
        const notifications = await getNotifications(useAuth().axiosConfig)(); // Chama sua função para obter notificações
        const unreadCount = notifications.filter(
          (n) => n.message !== ""
        ).length; // Contagem de notificações com mensagem
        setNotificationCount(unreadCount); // Define o estado com o número de notificações
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    if (token) {
      fetchNotificationsCount(); // Chama a contagem de notificações caso o usuário esteja logado
    }
  }, [token]);

  const handleBurguer = (target: HTMLInputElement) => {
    setIsDrawerOpen(target.checked);
  };

  return (
    <div
      id="navbar"
      className="items-center fixed top-0 z-99 h-[10vh] bg-white w-full shadow-xl !border-b-[1px]"
      ref={navRef}
    >
      {/* <div className="flex justify-end">
        {token && type !== "satelite" && (
          <>
            {t("greetings-user")}&nbsp;
            {user?.fullname}&nbsp;-&nbsp;
            <button
              className="!text-[#4E9600] w-auto bg-[#E1E7D6] !rounded-lg h-[35px] !border-r-black !font-[poppins]"
              onClick={() => handleLogout()}
            >
              {t("logout")}
            </button>
          </>
        )}
        <div className="flex justify-center items-center ml-[15px]">
          <select
            className="flex w-[72px] !text-[#50700f] !font-[poppins] text-base font-normal !text-[14px] outline-none !border-[1px] !border-white bg-transparent"
            onChange={(e) => changeLanguage(e.target.value)}
            defaultValue={i18n.language}
          >
            <option value="pt">PT-BR</option>
            <option value="en">EN-US</option>
          </select>
        </div>
      </div> */}
      <div
        className="flex justify-between h-full items-center mr-[1%]
            text-[#567712]
            !font-[poppins]
            max-[425px]:flex-wrap
            max-[425px]:ml-0
            max-[425px]:h-[200px]
            max-[425px]:gap-2
            max-[425px]:text-[0.5rem]
            max-[769px]:relative
            max-[769px]:flex-row-reverse
            max-[769px]:px-8
            
                "
      >
        <a
          className="relative ml-[2rem] cursor-pointer font-normal !text-[14px] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[#5C8014] after:scale-x-0 after:origin-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-left"
          onClick={() => {
            navigate("");
          }}
          href="/"
        >
          <img
            src={ic_logo}
            alt="Logo"
            className="w-[180px] max-w-[180px] h-auto
              max-[425px]:hidden
            "
            onClick={() => {
              token && navigate("/homeBuy");
            }}
          />
        </a>
        <div className="flex items-center gap-4">
        <button
          className="relative !inline-block w-[11em] h-[2.6em] font-normal !text-[14px] !overflow-hidden cursor-pointer z-[1] !text-[#5C8014] !border-[#5C8014] !rounded-[6px] before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]
              max-[769px]:!hidden
            "
          onClick={() => {
            navigate("/pronouncement");
          }}
        >
          {t("Pronouncements")}
        </button>

        {type !== "seller" && (
          <button
            className="relative !inline-block w-[11em] h-[2.6em] font-normal !text-[14px] !overflow-hidden cursor-pointer z-[1] !text-[#5C8014] !border-[#5C8014] !rounded-[6px] before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]
                  max-[769px]:!hidden
                "
            onClick={() => {
              navigate("/news");
            }}
          >
            {t("properties")}
          </button>
        )}
        <button
          className="relative !inline-block w-[11em] h-[2.6em] font-normal !text-[14px] !overflow-hidden cursor-pointer z-[1] !text-[#5C8014] !border-[#5C8014] !rounded-[6px] before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]
                max-[769px]:!hidden
              "
          onClick={() => {
            navigate("/catalog");
          }}
        >
          {t("catalog")}
        </button>
        <button
          className="relative !inline-block w-[13em] h-[2.6em] font-normal !text-[14px] !overflow-hidden cursor-pointer z-[1] !text-[#5C8014] !border-[#5C8014] !rounded-[6px] before:absolute before:content-[''] before:bg-[#5C8014] before:w-[300px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-38px]
                max-[769px]:!hidden
              "
          onClick={() => {
            navigate("/satelite");
          }}
        >
          {t("satelite")}
        </button>
        <button
          className="relative !inline-block w-[11em] h-[2.6em] font-normal !text-[14px] !overflow-hidden cursor-pointer z-[1] !text-[#5C8014] !border-[#5C8014] !rounded-[6px] before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]
              max-[769px]:!hidden
            "
          onClick={() => {
            navigate("/contact");
          }}
        >
          {t("contact-us")}
        </button>

        {token && (
          <>
            <button
              className="relative !inline-block w-[11em] h-[2.6em] font-normal !text-[14px] !overflow-hidden cursor-pointer z-[1] !text-[#5C8014] !border-[#5C8014] !rounded-[6px] before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]
                  max-[769px]:!hidden
                "
              onClick={() => {
                navigate("/mySpace");
              }}
            >
              {type === "satelite" && (
                <div
                  style={{
                    position: "absolute",
                    right: "0",
                  }}
                >
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      navigate("/choice");
                    }}
                  >
                    <a className="cursor-pointer !bg-[#50700f] font-[poppins] text-[16px] hover:border-b hover:border-[#96d2f4] max-[425px]:hidden">
                      {t("login")} | {t("sign-up")}
                    </a>
                  </span>
                </div>
              )}
              {type !== "satelite" && t("my-space")}
            </button>
            {/*
            <a
              className="relative cursor-pointer font-normal !text-[14px] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[#5C8014] after:scale-x-0 after:origin-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-left"
              onClick={() => {
                navigate("/mySpace");
              }}
            >
              {t("notifications")}
              {notificationCount > 0 && (
                <span
                  style={{
                    marginLeft: "8px",
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "50%",
                    padding: "4px 8px",
                    fontSize: "0.8em",
                  }}
                >
                  {notificationCount}{" "}
                </span>
              )}
            </a>
            */}

            {type === "seller" && (
              <a
                className="cursor-pointer font-normal !text-[14px]"
                onClick={() => {
                  navigate("/registerProperty");
                }}
              >
                <button className="relative !overflow-hidden !border-[3px] !border-[#50700f] !rounded-[40px] !font-[poppins] !text-[13px] w-[100px] h-[45px] !text-[#50700f] cursor-pointer before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:z-[-1] before:rounded-[50%] hover:!text-white hover:delay-[0.2s] before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]">
                  {t("sell-credits")}
                </button>
              </a>
            )}

            {type === "buyer" && (
              <a
                className="relative cursor-pointer font-normal !text-[14px]"
                onClick={() => {
                  navigate("/order");
                }}
              >
                <div className="relative !overflow-hidden !border-[3px] !border-collapse !border-[#50700f] !rounded-[50%] !font-[poppins] !text-[13px] p-[5px] !text-[#50700f] cursor-pointer hover:!bg-[#50700f] hover:delay-500 duration-300 before:absolute before:content-[''] before:bg-[#5C8014] before:w-[250px] before:h-[200px] before:!z-[-1] before:rounded-[50%] hover:!text-white before:top-full before:left-full before:transition-all before:duration-[0.5s] hover:before:top-[-30px] hover:before:left-[-33px]">
                  <BsCart4 size={28} />
                </div>
              </a>
            )}
          </>
        )}

        <div className="flex !font-[poppins] !text-[15px] items-center">
          {token && type === "cliente" ? (
            <a
              onClick={() => {
                navigate("/order");
              }}
            >
              <div
                style={{
                  border: "2px solid #50700F",
                  borderRadius: "50%",
                  padding: "10px",
                }}
              >
                <IoCartOutline size={25} color="#50700F" />
              </div>
            </a>
          ) : (
            ""
          )}
          {!isLoading && (
            <>
              <span>
                {!token && (
                  <div className="bg-[#50700f] p-3 mr-10 rounded-[6px] max-[769px]:!hidden">
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        navigate("/choice");
                      }}
                    >
                      <a
                        className="relative cursor-pointer !text-white font-[poppins] text-[14px] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:!bg-white after:scale-x-0 after:origin-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-left
                          
                        "
                      >
                        {t("login")} | {t("sign-up")}
                      </a>
                    </span>
                  </div>
                )}
                {token && type === "cliente" ? (
                  data && (
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        token ? navigate("/profile") : navigate("/choice");
                      }}
                    >
                      {data?.corporate_name
                        ? data?.corporate_name
                        : data?.name + " " + data?.surname}
                    </span>
                  )
                ) : token && type === "vendedor" ? (
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      token ? navigate("/profile") : navigate("/choice");
                    }}
                  >
                    {data?.corporate_name
                      ? data?.corporate_name
                      : data?.business_name}
                  </span>
                ) : token && type === "engenheiro" ? (
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      token ? navigate("/profile") : navigate("/choice");
                    }}
                  >
                    {data?.corporate_name
                      ? data?.corporate_name
                      : data?.business_name}
                  </span>
                ) : null}
              </span>
            </>
          )}
          {isLoading && <a>Carregando...</a>}
        </div>
        <div className="hidden max-[769px]:block">
          <label className="relative w-8 h-6 cursor-pointer block mr-8">
            <input
              type="checkbox"
              id="burger"
              className="peer hidden"
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            />
            <span className="absolute h-1 w-full bg-black rounded-full left-0 top-0 origin-left transition-all duration-300 ease-in-out peer-checked:rotate-45 peer-checked:top-0 peer-checked:left-1"></span>
            <span className="absolute h-1 w-full bg-black rounded-full left-0 top-1/2 -translate-y-1/2 origin-left transition-all duration-300 ease-in-out peer-checked:opacity-0 peer-checked:w-0"></span>
            <span className="absolute h-1 w-full bg-black rounded-full left-0 bottom-0 origin-left transition-all duration-300 ease-in-out peer-checked:rotate-[-45deg] peer-checked:bottom-0 peer-checked:left-1"></span>
          </label>
        </div>
        <div
          className={`absolute !border-none top-full right-full w-[250px] h-screen bg-white shadow-lg z-[100] transform ${
            isDrawerOpen ? "translate-x-full" : "translate-x-0"
          } transition-transform duration-300 ease-in-out`}
        >
          <ul className="flex flex-col gap-15 !p-[20px]">
            <li
              className="cursor-pointer mt-10 hover:text-[#5C8014]"
              onClick={() => {
                navigate("/homeBuy");
                setIsDrawerOpen(false);
              }}
            >
              🏠 {t("home")}
            </li>
            <li
              className="cursor-pointer hover:text-[#5C8014]"
              onClick={() => {
                navigate("/catalog");
                setIsDrawerOpen(false);
              }}
            >
              📦 {t("catalog")}
            </li>
            <li
              className="cursor-pointer hover:text-[#5C8014]"
              onClick={() => {
                navigate("/pronouncement");
                setIsDrawerOpen(false);
              }}
            >
              📢 {t("Pronouncements")}
            </li>
            <li
              className="cursor-pointer hover:text-[#5C8014]"
              onClick={() => {
                navigate("/contact");
                setIsDrawerOpen(false);
              }}
            >
              ☎ {t("contact-us")}
            </li>
            <li
              className="cursor-pointer hover:text-[#5C8014]"
              onClick={() => {
                handleLogout();
                setIsDrawerOpen(false);
              }}
            >
              🚪 {t("logout")}
            </li>
          </ul>
        </div>
        <div className="flex gap-5">
          {token && type !== "satelite" && (
            <span className="flex flex-row items-center">
              {t("greetings-user")}&nbsp;
              {user?.fullname}&nbsp;-&nbsp;
              <button
                className="!text-[#4E9600] w-auto bg-[#E1E7D6] !rounded-lg h-[35px] !border-r-black !font-[poppins]"
                onClick={() => handleLogout()}
              >
                {t("logout")}
              </button>
            </span>
          )}
          {/* <div className="flex justify-center items-center">
            <select
              className="flex w-[72px] !text-[#50700f] !font-[poppins] text-base font-normal !text-[14px] outline-none !border-[1px] !border-white bg-transparent"
              onChange={(e) => changeLanguage(e.target.value)}
              defaultValue={i18n.language}
            >
              <option value="pt">PT-BR</option>
              <option value="en">EN-US</option>
            </select>
          </div> */}
        </div>
        </div>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay style={{ width: "100%", height: "100%" }} />
        <ModalContent>
          <ModalHeader>
            <h1 className="!font-[poppins] !text-black !text-[22px]">
              Atenção
            </h1>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <h1 className="!font-[poppins] !text-black !text-[15px]">
              {" "}
              Para acessar essa funcionalidade é necessário estar logado. Faça o
              login ou se cadastre na plataforma!
            </h1>
          </ModalBody>

          <ModalFooter>
            <button
              className="bg-[#E1E7D6] rounded-lg h-[35px] w-[80%] border-r-black font-[poppins] text-white"
              onClick={onClose}
            >
              Fechar
            </button>
            <div className="mr-20px" />
            <button
              className="bg-[#E1E7D6] rounded-lg h-[35px] w-[80%] border-r-black font-[poppins] text-white"
              onClick={() => navigate("/choice")}
            >
              Login ou Cadastrar
            </button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isOpenTermsOfUse}
        closeOnEsc={false}
        onClose={() => {
          return;
        }}
        closeOnOverlayClick={false}
      >
        <ModalOverlay style={{ width: "100%", height: "100%" }} />
        <ModalContent>
          <ModalHeader>
            <h1 className="!font-[poppins] !text-black !text-[22px]">
              {t("terms-of-use")}
            </h1>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div
              dangerouslySetInnerHTML={{
                __html: contentTerms || "",
              }}
            />
          </ModalBody>
          <ModalFooter>
            <div className="flex w-full justify-around">
              <button
                className="!bg-[#45B7FE] !rounded-[8px] h-[35px] w-[40%] !border-r-black !font-[poppins] !text-white"
                onClick={acceptTermsOfUseClick}
              >
                {t("accept-the-terms")}
              </button>
              <button
                className="!bg-[#F5C723] !rounded-[8px] h-[35px] w-[40%] !border-r-[#000] !font-[poppins] !text-white"
                onClick={onCloseTermsOfUse}
              >
                {t("close")}
              </button>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default NavBar;
